import { Router } from "../@noxtum/router/Router";
import { Dashboard } from "../admin/Dashboard";
import { CheckoutPage } from "./CheckoutPage";
import { ContactPage } from "./ContactPage";
import { AboutCurrentCommittee } from "./data/about-current-committee";
import { AboutOutreach } from "./data/about-outreach";
import { AboutWhoWeAre } from "./data/about-who-we-are";
import { EventAwarenessWeek } from "./data/events-awareness-week";
import { EventsConference } from "./data/events-conference";
import { EventGeonight } from "./data/events-geonight";
import { EventsPast } from "./data/events-past";
import { EventsUpcoming } from "./data/events-upcoming";
import { Journal } from "./data/journal";
import { MembersResources } from "./data/members-resources";
import { MembersRules } from "./data/members-rules";
import { Projects } from "./data/projects";
import { StudyHigherEducation } from "./data/study-higher-education";
import { StudyPrimary } from "./data/study-primary";
import { TestGallery } from "./data/test-gallery";
import { DataPage } from "./DataPage";
import { HomePage } from "./HomePage";
import { JoinPage } from "./JoinPage";
import { MemberArea } from "./member/MemberArea";
import { MemberLanding } from "./member/MemberLanding";
import { MemberLogin } from "./member/MemberLogin";
import { ReturnPage } from "./ReturnPage";

export const pages: { title: string; url: string }[] = [
	{ title: "Home", url: "/home" },

	{ title: "Events — Conference", url: "/events/conference" },
	{ title: "Events — Upcoming", url: "/events/upcoming" },
	{ title: "Events — Awareness Week", url: "/events/awareness-week" },
	{ title: "Events — GeoNight", url: "/events/geonight" },
	{ title: "Events — Past", url: "/events/past" },

	{ title: "Study — Primary", url: "/study/primary" },
	{ title: "Study — Higher Education", url: "/study/higher-education" },

	{ title: "About — Contact", url: "/about/contact" },
	{ title: "About — Who We Are", url: "/about/who-we-are" },
	{ title: "About — Outreach", url: "/about/outreach" },
	{ title: "About — Current Committee", url: "/about/current-committee" },

	{ title: "Members — Renew / Join", url: "/members/renew-join" },
	{ title: "Members — Resources", url: "/members/resources" },
	{ title: "Members — Rules", url: "/members/rules" },
	{ title: "Members — Login", url: "/members/login" },
	{ title: "Members — Register", url: "/members/register" },
	{ title: "Members — Verify Email", url: "/members/verify-email" },
	{ title: "Members — Area", url: "/members/area" },

	{ title: "Test — Gallery", url: "/test/gallery" },

	{ title: "Payment", url: "/payment" },
	{ title: "Return", url: "/return" },
	{ title: "Admin", url: "/admin" },
];

export function registerRoutes() {

	Router.addHandler("home", (page, parts) => {
		return <HomePage page={page} parts={parts} />;
	});


	Router.addHandler("events", (page, parts) => {
		if (parts[0] === "conference") {
			return <DataPage key="events-conference" page={page} parts={parts} data={EventsConference} />;
		} else if (parts[0] === "upcoming") {
			return <DataPage key="events-upcoming" page={page} parts={parts} data={EventsUpcoming} />;
		} else if (parts[0] === "awareness-week") {
			return <DataPage key="events-awareness-week" page={page} parts={parts} data={EventAwarenessWeek} />;
		} else if (parts[0] === "geonight") {
			return <DataPage key="events-geonight" page={page} parts={parts} data={EventGeonight} />;
		} else if (parts[0] === "past") {
			return <DataPage key="events-past" page={page} parts={parts} data={EventsPast} />;
		} else {
			return <div class="ErrorPage">404 - Page Not Found</div>;
		}
	});

	Router.addHandler("study", (page, parts) => {
		if (parts[0] === "primary") {
			return <DataPage key="study-primary" page={page} parts={parts} data={StudyPrimary} />;
		} else if (parts[0] === "higher-education") {
			return <DataPage key="study-higher-education" page={page} parts={parts} data={StudyHigherEducation} />;
		} else {
			return <div class="ErrorPage">404 - Page Not Found</div>;
		}
	});

	Router.addHandler("journal", (page, parts) => {
		return <DataPage key="journal" page={page} parts={parts} data={Journal} />;
	});

	Router.addHandler("projects", (page, parts) => {
		return <DataPage key="projects" page={page} parts={parts} data={Projects} />;
	});

	Router.addHandler("about", (page, parts) => {
		if (parts[0] === "contact") {
			return <ContactPage page={page} parts={parts} />;
		} else if (parts[0] === "who-we-are") {
			return <DataPage key="about-who-we-are" page={page} parts={parts} data={AboutWhoWeAre} />;
		} else if (parts[0] === "outreach") {
			return <DataPage key="about-outreach" page={page} parts={parts} data={AboutOutreach} />;
		} else if (parts[0] === "current-committee") {
			return <DataPage key="about-current-committee" page={page} parts={parts} data={AboutCurrentCommittee} />;
		} else {
			return <div class="AboutPage">About Page Coming Soon</div>;
		}
	});

	Router.addHandler("members", (page, parts) => {
		if (parts[0] === "landing") {
			return <MemberLanding page={page} parts={parts} />;
		} else if (parts[0] === "renew-join") {
			return <JoinPage page={page} parts={parts} />;
		} else if (parts[0] === "resources") {
			return <DataPage key="members-resources" page={page} parts={parts} data={MembersResources} />;
		} else if (parts[0] === "rules") {
			return <DataPage key="members-rules" page={page} parts={parts} data={MembersRules} />;
		} else if (parts[0] === "login") {
			return <MemberLogin key="members-login" page={page} parts={parts} />;
		} else if (parts[0] === "register") {
			return <MemberLogin key="members-register" page={page} parts={parts} />;
		} else if (parts[0] === "verify-email") {
			return <MemberLogin key="members-verify-email" page={page} parts={parts} />;
		} else if (parts[0] === "area") {
			return <MemberArea page={page} parts={parts} />;
		} else {
			return <div class="MembersPage">Members Page Coming Soon</div>;
		}
	});

	Router.addHandler("test", (page, parts) => {
		if (parts[0] === "gallery") {
			return <DataPage key="test-gallery" page={page} parts={parts} data={TestGallery} />;
		} else {
			return <div class="MembersPage">Members Page Coming Soon</div>;
		}
	});

	Router.addHandler("payment", (page, parts) => {
		return <CheckoutPage page={page} parts={parts} />;
	});

	Router.addHandler("return", (page, parts) => {
		return <ReturnPage page={page} parts={parts} />;
	});

	Router.addHandler("error", (page, parts) => {
		return <div class="ErrorPage">404 - Page Not Found</div>;
	});

	Router.addHandler("admin", (page, parts) => {
		return <Dashboard page={page} parts={parts} />;
	});
}